import { configureStore } from "@reduxjs/toolkit";

import profileReducer from "./slices/profileSlice";
import pageSizeReducer from "./slices/pageSizeSlice";
import systemConfigurationReducer from "./slices/systemConfigurationSlice";
import permissionReducer from "./slices/permissionSlice";
import dashboardFilterReducer from "./slices/dashboardFilterSlice";
import nem12Reducer from "./slices/nem12Slice";

export const store = configureStore({
  reducer: {
    profile: profileReducer,
    pageSize: pageSizeReducer,
    systemConfiguration: systemConfigurationReducer,
    permission: permissionReducer,
    dashboardFilter: dashboardFilterReducer,
    nem12: nem12Reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
